/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';

import Input from 'components/forms/Input';
import PropTypes from 'prop-types';

const PasswordInput = ({
  errors,
  register,
  dirtyFields,
  isRequired,
  ...rest
}) => {
  const [showPassword, toggleShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    toggleShowPassword(!showPassword);
  };

  return (
    <Input
      autoComplete="current-password"
      isDirty={dirtyFields?.password}
      suffixIcon={{
        iconName: showPassword ? 'EyeOff' : 'Eye',
        clickHandler: togglePasswordVisibility,
        toolTip: showPassword ? 'Hide Password' : 'Show password'
      }}
      label={`Password${isRequired ? '*' : ''}`}
      name="password"
      error={errors?.password}
      type={showPassword ? 'text' : 'password'}
      inputRef={register({
        required: 'Please enter your password'
      })}
      {...rest}
    />
  );
};

PasswordInput.propTypes = {
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  dirtyFields: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  defaultValue: PropTypes.string,
  isRequired: PropTypes.bool
};

PasswordInput.defaultProps = {
  readOnly: false,
  defaultValue: '',
  isRequired: true
};

export default PasswordInput;
